<app-pan-modal #newPanobridgeModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Add New PanoBridge</div>
  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>PanoBridge Serial Number</app-pan-floating-label>
      <input panInput [(ngModel)]="newPanobridgeSerialNumber" placeholder="PanoBridge Serial Number..." />
    </app-pan-form-control>

    <app-page-select-branch
      [(selected)]="newPanobridgeBranch"
      [autoSelectBranchIds]="[branchId()]"
      [disabled]="true"
      (selectedChange)="loadLocations()"
    ></app-page-select-branch>

    <app-pan-form-control>
      <app-pan-floating-label>Location</app-pan-floating-label>

      <ng-select
        class="w-full mb-2"
        placeholder="Select location..."
        [items]="locations()"
        [bindLabel]="'name'"
        appendTo="body"
        [virtualScroll]="true"
        [disabled]="!newPanobridgeBranch() || isLoadingLocations()"
        [(ngModel)]="newPanobridgeLocation"
        [loading]="isLoadingLocations()"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Event Format</app-pan-floating-label>

      <ng-select
        class="w-full mb-2"
        placeholder="Select event format..."
        [items]="formatOptions"
        [bindLabel]="'name'"
        appendTo="body"
        [virtualScroll]="true"
        [(ngModel)]="newPanobridgeEventFormat"
        (ngModelChange)="forceUdp()"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Protocol</app-pan-floating-label>

      <ng-select
        class="w-full mb-2"
        placeholder="Select protocol..."
        [items]="['tcp', 'udp']"
        appendTo="body"
        [virtualScroll]="true"
        [disabled]="disableProtocolSelection()"
        [(ngModel)]="newPanobridgeProtocol"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Port</app-pan-floating-label>
      <input panInput type="number" [(ngModel)]="newPanobridgePort" placeholder="PanoBridge port..." />
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button
      panModalClose
      color="primary"
      (click)="addPanobridge()"
      [disabled]="
        !newPanobridgeSerialNumber() ||
        !newPanobridgeBranch() ||
        !newPanobridgeLocation() ||
        !newPanobridgePort() ||
        !newPanobridgeProtocol()
      "
      >Connect PanoBridge</app-pan-button
    >
  </div>
</app-pan-modal>

<app-pan-section-header class="mt-4" title="PanoBridge Configurations">
  <div action class="flex gap-2">
    <app-pan-button panRole [roles]="['admin']" icon="add" color="primary" (click)="newPanobridgeModal.show()"></app-pan-button>
  </div>
</app-pan-section-header>

<ag-grid-angular #locationGrid [rowData]="panobridges()" [columnDefs]="panobridgeColumns" [gridOptions]="panobridgeTable"></ag-grid-angular>
